import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'
import { useEffect, useMemo } from 'react'

import { ICrudFetchOptions } from 'clickNgo/models/crud/utils'
import { IDataProviderFilter, Logic } from 'core-components/types'
import { CrudStore } from 'core/types/crudStore'

import { ProfilingCodeType } from '../../model/types'

export const useProfilingCodeSource = (
  types?: ProfilingCodeType[],
  options?: ICrudFetchOptions
) => {
  const source = useMemo(
    () => CrudStore.get(CrudStoreItem.CodesDictionary, options?.cacheKey ?? 'ProfilingCodeOptions'),
    [options?.cacheKey]
  )

  const filters = useMemo(() => {
    const baseFilters: IDataProviderFilter = {
      logic: Logic.AND,
      filters: [],
    }

    if (options?.filters) {
      baseFilters.filters.push(options.filters)
    }

    if (types && types.length > 0) {
      baseFilters.filters.push({
        logic: Logic.OR,
        filters: types.map((type) => ({ field: 'type', operator: 'contains', value: type })),
      })
    }

    return baseFilters.filters.length > 0 ? baseFilters : undefined
  }, [options?.filters, types])

  useEffect(() => {
    source.setFilter(filters)
  }, [filters, source])

  useEffect(() => {
    source.keyField = 'Code'
  }, [source])

  return source
}
